var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 15.0623V20.1263H11.5V15.0623H12.5Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8662 5.56738C10.9256 5.56738 9.342 7.03657 9.16617 8.91211C9.14637 9.12333 8.99543 9.29906 8.78962 9.35051C7.68919 9.62562 6.90285 10.6173 6.90285 11.8639C6.90285 13.2607 8.0187 14.429 9.46794 14.429C10.1381 14.429 10.8096 14.1463 11.2466 13.7092C11.3692 13.5867 11.5464 13.5363 11.7151 13.5762C11.8837 13.616 12.0197 13.7403 12.0745 13.9047C12.4044 14.8942 13.4085 15.6284 14.532 15.6284C15.9288 15.6284 17.0971 14.5125 17.0971 13.0633C17.0971 12.3301 16.8161 11.7116 16.4212 11.2603C16.3 11.1218 16.2647 10.9278 16.3294 10.7555C16.5158 10.2582 16.6307 9.78653 16.6307 9.26523C16.6307 7.21943 14.9325 5.56738 12.8662 5.56738ZM8.21457 8.48121C8.58737 6.25667 10.526 4.56738 12.8662 4.56738C15.4642 4.56738 17.6307 6.64676 17.6307 9.26523C17.6307 9.83619 17.5232 10.3478 17.3618 10.8348C17.7993 11.4238 18.0971 12.1849 18.0971 13.0633C18.0971 15.0789 16.4669 16.6284 14.532 16.6284C13.2322 16.6284 12.037 15.9189 11.4124 14.8518C10.8459 15.2178 10.1573 15.429 9.46794 15.429C7.45229 15.429 5.90285 13.7987 5.90285 11.8639C5.90285 10.3008 6.83136 8.9771 8.21457 8.48121Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNature);
export default __webpack_public_path__ + "static/media/nature.40fcb70998361a15848fcd90995441ab.svg";
export { ForwardRef as ReactComponent };